import {Component} from "react";

export default class AppFormDefault extends Component {
  onChangeData = (objData) => {
    this.setState({
      data: {
        ...this.state.data,
        ...objData,
      }
    })
  }

  handlerOnSubmit = (e) => {
    e.preventDefault();
  }

  getDataToSubmit = () => {
    return this.state.data;
  }

  submit = () => {
    return this.props.onSubmit(this.getDataToSubmit())
  }
}
